<form [formGroup]="addClientForm" (ngSubmit)="addClient()">
  <div class="row">
    <div class="form-group col-md-3">
      <label>Name <span class="text-danger small">(required)</span></label>
      <input type="text" class="form-control" [ngClass]="setClassInvalid(addClientForm, 'name')"
        formControlName="name" placeholder="Name" required>
    </div>
    <div class="form-group col-md-3">
      <label>Website <span class="text-danger small">(required)</span></label>
      <input type="url" class="form-control" [ngClass]="setClassInvalid(addClientForm, 'website')"
        formControlName="website" [pattern]="urlRegexp" placeholder="https://example.com" required>
      </div>
      <div class="form-group col-md-3">
        <label>Topic <span class="text-danger small">(required)</span></label>
        <select class="form-control" [ngClass]="setClassInvalid(addClientForm, 'cluster')"
          formControlName="cluster" required>
        <option value="" selected>Select topic</option>
        @for (cluster of clusters; track cluster) {
          <option [value]="cluster">{{cluster}}</option>
        }
      </select>
    </div>
    <div class="form-group col-md-3">
      <label>Category</label>
      <select class="form-control" [ngClass]="setClassInvalid(addClientForm, 'category')"
        formControlName="category">
        <option value="" selected>Select category</option>
        @for (category of categories; track category) {
          <option [value]="category">{{category}}</option>
        }
      </select>
    </div>
  </div>
  <div class="row">
    <!-- Cant use 2 app-search-input with same model -->
  <div class="form-group col-md-6">
    <label class="me-1">Team members allowed to see this client and its records:
      <span class="badge badge-primary me-1" data-bs-toggle="tooltip" data-placement="top" [title]="directorLastNames">
        Directors <i class="fa fa-times-circle disabled"></i>
      </span>
    </label>
    <input type="hidden" class="form-control" formControlName="_users">
    <app-search-input model="user"></app-search-input>
  </div>
  <div class="form-group col-md-6">
    <label>Google Drive folder <span class="text-danger small">(required)</span></label>
    <input type="url" class="form-control" [ngClass]="setClassInvalid(addClientForm, 'driveurl')"
      formControlName="driveurl" [pattern]="urlRegexp" placeholder="https://drive.google.com/drive/folders/abc123" required>
    </div>
  </div>
  <div class="row">
    <div class="form-group col-md-6">
      <label>Notes</label>
      <textarea class="form-control" rows="5" [ngClass]="setClassInvalid(addClientForm, 'notes')"
      formControlName="notes" placeholder="Notes"></textarea>
    </div>
  </div>
  <div formGroupName="socials" class="row">
    <div formGroupName="twitter" class="form-group col-md-3">
      <label>X <span class="text-danger small">(required only for logo retrival)</span></label>
      <input type="text" class="form-control" [ngClass]="setClassInvalid(addClientForm, 'socials.twitter.username')"
        formControlName="username" placeholder="mario_rossi">
    </div>
    <div formGroupName="instagram" class="form-group col-md-3">
      <label>Instagram</label>
      <input type="text" class="form-control" [ngClass]="setClassInvalid(addClientForm, 'socials.instagram.username')"
        formControlName="username" placeholder="mario.rossi">
    </div>
    <div formGroupName="facebook" class="form-group col-md-3">
      <label>Facebook</label>
      <input type="text" class="form-control" [ngClass]="setClassInvalid(addClientForm, 'socials.facebook.username')"
        formControlName="username" placeholder="MarioRossiOfficial">
    </div>
    <div formGroupName="linkedin" class="form-group col-md-3">
      <label>LinkedIn</label>
      <input type="text" class="form-control" [ngClass]="setClassInvalid(addClientForm, 'socials.linkedin.username')"
        formControlName="username" placeholder="mario-rossi">
    </div>
  </div>
  <div class="row">
    <div class="form-group col-md-12">
      <button class="btn btn-primary" type="submit" [disabled]="!addClientForm.valid">
        <i class="fa fa-user-plus"></i> Add client
      </button>
    </div>
  </div>
</form>